import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './vant';
import { isProd } from '@/utils/env';
import { CoreLMGetID1 } from './utils/app-core';
import initWebBuried from '@/utils/webBuired';

import Vconsole from 'vconsole';
if (!isProd) {
    const vConsole = new Vconsole();
    Vue.use(vConsole);
}

// 获取用户信息
CoreLMGetID1().then(res => {
    console.log('mainjs-LMGetID', res);
    window._userInfo = res;
});

// 登录成功后重新缓存用户信息
window.LMRtnStr = (data) => {
    console.log('进入了main方法回调!', data);
    window._userInfo = JSON.parse(data);
};

// 初始化埋点
initWebBuried();

//压缩图片
const checkWebpFeature = (feature, callback) => {
    var kTestImages = {
        lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
        lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
        alpha: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
        animation: 'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA'
    };
    var img = new Image();
    img.onload = function () {
        var result = (img.width > 0) && (img.height > 0);
        callback(feature, result);
    };
    img.onerror = function () {
        callback(feature, false);
    };
    img.src = 'data:image/webp;base64,' + kTestImages[feature];
};

checkWebpFeature('lossy', function (feature, isSupported) {
    if (isSupported) {
        Vue.prototype.isSupportWebp = true;
    } else {
        Vue.prototype.isSupportWebp = false;
    }
});

Vue.config.productionTip = false;


new Vue({
    render: h => h(App),
    router
}).$mount('#app');
